function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5cc3b6;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M566.82,371.05,579.14,379a59.27,59.27,0,0,1,17.57,81.67L477.42,645.28a59.23,59.23,0,0,1-81.67,17.54l-12.28-7.94a59.19,59.19,0,0,1-17.55-81.64L485.19,388.6A59.22,59.22,0,0,1,566.82,371.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M678.39,443.15l12.32,7.94a59.22,59.22,0,0,1,17.58,81.64L589,717.37a59.2,59.2,0,0,1-81.64,17.55L495,727a59.22,59.22,0,0,1-17.55-81.66L596.77,460.69A59.19,59.19,0,0,1,678.39,443.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M172.21,537.18,62.93,113a67.68,67.68,0,0,1,48.41-82.3l13.73-3.59A67.76,67.76,0,0,1,207.4,75.56L320.34,464"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M503,370.8l79.7-257.74a67.76,67.76,0,0,0-48.41-82.35l-13.76-3.54a67.71,67.71,0,0,0-82.32,48.4L320.36,464"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M383.14,928.61C370.8,805.81,206.67,751.2,206.67,751.2l-13.58-57.08,77.68-53.91c30.48-24.76,34.27-66.47,14-102.8-15.91-28.44-48.88-17-48.88-17S90.36,556.12,58.91,576.81C-8.6,621.19,41,790.42,68.36,842.22S173,1053.38,173,1053.38l10,71.69"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "715.46 516.94 697.12 824.93 592.88 1053.39"
})));

function SvgLeft2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 742.68 1150.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft2);
export default __webpack_public_path__ + "static/media/left-2.a76d0cc4.svg";
export { ForwardRef as ReactComponent };